export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AcceptInvitationInput = {
  id: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};

export type AcceptInvitationPayload = {
  __typename?: 'AcceptInvitationPayload';
  id: Scalars['ID']['output'];
  orgId: Scalars['ID']['output'];
};

export type ActingUser = {
  __typename?: 'ActingUser';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['ID']['output']>;
  orgName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type ActivityChangedAttributes = {
  __typename?: 'ActivityChangedAttributes';
  attributes: Array<ChangedAttribute>;
};

export type ActivityChangedLicenseSystemAccess = {
  __typename?: 'ActivityChangedLicenseSystemAccess';
  licenseSystemIds: Array<Scalars['String']['output']>;
  moduleId: Scalars['String']['output'];
  role?: Maybe<LicenseSystemAccessRole>;
};

export type ActivityChangedModuleAccess = {
  __typename?: 'ActivityChangedModuleAccess';
  moduleIds: Array<Scalars['String']['output']>;
};

export type ActivityChangedSiteAccess = {
  __typename?: 'ActivityChangedSiteAccess';
  headOrg?: Maybe<ActivitySiteOrg>;
  sites?: Maybe<Array<ActivitySiteOrg>>;
};

export type ActivityClosedSessions = {
  __typename?: 'ActivityClosedSessions';
  appNames: Array<Scalars['String']['output']>;
};

export type ActivityDetails = ActivityChangedAttributes | ActivityChangedLicenseSystemAccess | ActivityChangedModuleAccess | ActivityChangedSiteAccess | ActivityClosedSessions | ActivityDownloadedLicenseSystemUpdate;

export type ActivityDownloadedLicenseSystemUpdate = {
  __typename?: 'ActivityDownloadedLicenseSystemUpdate';
  updateNumber: Scalars['Int']['output'];
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  actingUser: ActingUser;
  activityDetails?: Maybe<ActivityDetails>;
  activityId: Scalars['ID']['output'];
  activityType: ActivityType;
  targetResource: TargetResource;
  timestamp: Scalars['String']['output'];
};

export type ActivitySiteOrg = {
  __typename?: 'ActivitySiteOrg';
  orgId: Scalars['ID']['output'];
  orgName: Scalars['String']['output'];
};

export enum ActivityType {
  AddLicenseSystemToOrg = 'AddLicenseSystemToOrg',
  AssignLicenseSystemAccessToUser = 'AssignLicenseSystemAccessToUser',
  AssignModulesToUser = 'AssignModulesToUser',
  AssignSitesToOrganization = 'AssignSitesToOrganization',
  ChangeUserName = 'ChangeUserName',
  CloseActiveSessions = 'CloseActiveSessions',
  CompleteLicensesTransfer = 'CompleteLicensesTransfer',
  CreateOrganization = 'CreateOrganization',
  DeleteUser = 'DeleteUser',
  DownloadLicenseUpdate = 'DownloadLicenseUpdate',
  EditLicenseSystem = 'EditLicenseSystem',
  EditOrganization = 'EditOrganization',
  EditUser = 'EditUser',
  FailLicensesTransfer = 'FailLicensesTransfer',
  InviteUserToOrg = 'InviteUserToOrg',
  JoinOrganization = 'JoinOrganization',
  RemoveLicenseSystemAccessFromUser = 'RemoveLicenseSystemAccessFromUser',
  RemoveLicenseSystemFromOrg = 'RemoveLicenseSystemFromOrg',
  RemoveModulesFromUser = 'RemoveModulesFromUser',
  RemoveSitesFromOrganization = 'RemoveSitesFromOrganization',
  RequestCreateLicenseSystem = 'RequestCreateLicenseSystem',
  RequestLicensesTransfer = 'RequestLicensesTransfer',
  RequestRepairLicenseSystem = 'RequestRepairLicenseSystem',
  RequestTemporaryLicenses = 'RequestTemporaryLicenses',
  ResendInviteToOrg = 'ResendInviteToOrg'
}

export type AddLicenseSystemInput = {
  file: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
};

export type AddLicenseSystemPayload = {
  __typename?: 'AddLicenseSystemPayload';
  messageId: Scalars['String']['output'];
  succeeded: Scalars['Boolean']['output'];
};

export type AddOrDeleteOrganizationPayload = {
  __typename?: 'AddOrDeleteOrganizationPayload';
  id?: Maybe<Scalars['ID']['output']>;
};

export type AddOrganizationInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  isAllowedToUseLicenseSystemsOffline: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type Admin = {
  __typename?: 'Admin';
  email: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type ApplicationSettingsPayload = {
  __typename?: 'ApplicationSettingsPayload';
  settings: Array<Setting>;
};

export type AssetInput = {
  id: Scalars['ID']['input'];
  type: AssetType;
};

export enum AssetType {
  Measurement = 'Measurement'
}

export type AssignLicenseSystemToOrgInput = {
  licenseSystemId: Scalars['ID']['input'];
  orgId?: InputMaybe<Scalars['ID']['input']>;
};

export type AssignLicenseSystemToOrgPayload = {
  __typename?: 'AssignLicenseSystemToOrgPayload';
  licenseSystemId: Scalars['ID']['output'];
  succeeded: Scalars['Boolean']['output'];
};

export type AssignSitesToOrganizationInput = {
  parentOrgId: Scalars['ID']['input'];
  siteOrgIds: Array<Scalars['ID']['input']>;
};

export type AssignSitesToOrganizationPayload = {
  __typename?: 'AssignSitesToOrganizationPayload';
  parentOrgId: Scalars['ID']['output'];
  siteOrgIds: Array<Scalars['ID']['output']>;
};

export type BalanceItem = {
  __typename?: 'BalanceItem';
  expirationDate?: Maybe<Scalars['String']['output']>;
  fromContract: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  startDate: Scalars['String']['output'];
  used: Scalars['Int']['output'];
};

export type BalanceSummary = {
  __typename?: 'BalanceSummary';
  remaining: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

export type ChangedAttribute = {
  __typename?: 'ChangedAttribute';
  name: Scalars['String']['output'];
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
};

export type CloseActiveUserSessionsInput = {
  orgId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type CloseActiveUserSessionsPayload = {
  __typename?: 'CloseActiveUserSessionsPayload';
  closedSessionsCount: Scalars['Int']['output'];
  succeeded: Scalars['Boolean']['output'];
};

export type ColorProofGoAttributes = {
  __typename?: 'ColorProofGoAttributes';
  isLicensed: Scalars['Boolean']['output'];
  isOnline: Scalars['Boolean']['output'];
  onlineStatusChangeTimestamp?: Maybe<Scalars['String']['output']>;
};

export type CompleteAddLicenseSystemInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<LicenseSystemFailureInput>;
  licenseSystemId?: InputMaybe<Scalars['ID']['input']>;
  messageId: Scalars['String']['input'];
};

export type CompleteAddLicenseSystemPayload = {
  __typename?: 'CompleteAddLicenseSystemPayload';
  data?: Maybe<Scalars['String']['output']>;
  error?: Maybe<LicenseSystemFailureError>;
  licenseSystemId?: Maybe<Scalars['ID']['output']>;
  messageId: Scalars['String']['output'];
};

export type CompleteReactivateLicenseSystemInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<LicenseSystemFailureInput>;
  licenseSystemId?: InputMaybe<Scalars['ID']['input']>;
  messageId: Scalars['String']['input'];
};

export type CompleteReactivateLicenseSystemPayload = {
  __typename?: 'CompleteReactivateLicenseSystemPayload';
  data?: Maybe<Scalars['String']['output']>;
  error?: Maybe<LicenseSystemFailureError>;
  licenseSystemId?: Maybe<Scalars['ID']['output']>;
  messageId: Scalars['String']['output'];
};

export type Computer = {
  __typename?: 'Computer';
  appServiceVersion?: Maybe<Scalars['String']['output']>;
  installedUpdateNumber?: Maybe<Scalars['Int']['output']>;
  lastSeenDate?: Maybe<Scalars['String']['output']>;
};

export type ContractStatus = {
  __typename?: 'ContractStatus';
  hasContract: Scalars['Boolean']['output'];
  nearestExpiringContract?: Maybe<NearestExpiringContract>;
};

export type CounterLimit = {
  __typename?: 'CounterLimit';
  availableNumber: Scalars['Int']['output'];
  totalNumberInContracts: Scalars['Int']['output'];
};

export type CreateFolderInput = {
  editorGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['ID']['input']>;
  parentFolder?: InputMaybe<Scalars['ID']['input']>;
  readerGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateLicenseSystemAccessInput = {
  licenseSystemId: Scalars['ID']['input'];
  moduleName: ModuleName;
};

export type CreateLicenseSystemAccessPayload = {
  __typename?: 'CreateLicenseSystemAccessPayload';
  userId: Scalars['ID']['output'];
};

export type CreateOrEditFolderPayload = {
  __typename?: 'CreateOrEditFolderPayload';
  id?: Maybe<Scalars['ID']['output']>;
};

export type CreateOrEditUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  /**   TODO: Make firstName and lastName required once the frontend supports it. Remove groups. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  groups: Array<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  licenseSystemAccess?: InputMaybe<LicenseSystemAccess>;
  modules: Array<Scalars['String']['input']>;
  orgId: Scalars['ID']['input'];
  role: Role;
};

export type CreateTemporaryLicensesInput = {
  licenseSystemId: Scalars['ID']['input'];
  orgId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateTemporaryLicensesPayload = {
  __typename?: 'CreateTemporaryLicensesPayload';
  licenseSystemId: Scalars['ID']['output'];
  succeeded: Scalars['Boolean']['output'];
};

export type DeleteFolderInput = {
  assetsToBeDeleted?: InputMaybe<Array<AssetInput>>;
  folderIds: Array<Scalars['ID']['input']>;
};

export type DeleteFolderPayload = {
  __typename?: 'DeleteFolderPayload';
  deletedFolders: Array<Scalars['ID']['output']>;
  succeeded: Scalars['Boolean']['output'];
};

/**   used for users, groups, folders */
export type DeleteOrganizationReferenceInput = {
  id: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};

export type EditFolderInput = {
  editorGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['ID']['input']>;
  parentFolder?: InputMaybe<Scalars['ID']['input']>;
  readerGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EditLicenseSystemInput = {
  licenseSystemId: Scalars['ID']['input'];
  location: Scalars['String']['input'];
};

export type EditLicenseSystemPayload = {
  __typename?: 'EditLicenseSystemPayload';
  licenseSystemId: Scalars['ID']['output'];
  succeeded: Scalars['Boolean']['output'];
};

export type EditOrganizationInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  contactPerson: Scalars['String']['input'];
  contactPhone: Scalars['String']['input'];
  country: Scalars['String']['input'];
  /**   isAllowedToUseLicenseSystemsOffline optional, because customers do not have permission to change it */
  isAllowedToUseLicenseSystemsOffline?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type EditOrganizationPayload = {
  __typename?: 'EditOrganizationPayload';
  id?: Maybe<Scalars['ID']['output']>;
};

export type Folder = {
  __typename?: 'Folder';
  editorGroupCount?: Maybe<Scalars['Int']['output']>;
  editorGroups?: Maybe<Array<UserGroupFolderParams>>;
  fullPath?: Maybe<Array<PathElement>>;
  id: Scalars['ID']['output'];
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  isTraversable?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  orgId: Scalars['ID']['output'];
  parentFolderId?: Maybe<Scalars['ID']['output']>;
  readerGroupCount?: Maybe<Scalars['Int']['output']>;
  readerGroups?: Maybe<Array<UserGroupFolderParams>>;
};

export type GetAllProductsPayload = {
  __typename?: 'GetAllProductsPayload';
  products: Array<Product>;
  webApplications: Array<WebApplication>;
};

export type GetColorCardBalanceItemsByOrgIdPayload = {
  __typename?: 'GetColorCardBalanceItemsByOrgIdPayload';
  balanceItems: Array<BalanceItem>;
  balanceSummary: BalanceSummary;
};

export type GetFolderPayload = {
  __typename?: 'GetFolderPayload';
  folder?: Maybe<Folder>;
};

export type GetLicenseSystemAccessByCurrentUserInput = {
  moduleName: ModuleName;
};

export type GetLicenseSystemAccessByCurrentUserPayload = {
  __typename?: 'GetLicenseSystemAccessByCurrentUserPayload';
  licenseSystemAccessItems: Array<LicenseSystemAccessItem>;
  userId: Scalars['ID']['output'];
};

export type GetLicenseSystemAccessByUserIdInput = {
  moduleName: ModuleName;
  targetUserId: Scalars['ID']['input'];
};

export type GetLicenseSystemAccessByUserIdPayload = {
  __typename?: 'GetLicenseSystemAccessByUserIdPayload';
  licenseSystemAccessItems?: Maybe<Array<LicenseSystemAccessItem>>;
};

export type GetLicenseSystemDetailsInput = {
  licenseSystemId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};

export type GetLicenseSystemDetailsPayload = {
  __typename?: 'GetLicenseSystemDetailsPayload';
  addedByAdmin: Admin;
  computer: Computer;
  updateNumber?: Maybe<Scalars['Int']['output']>;
  updateTimeStamp?: Maybe<Scalars['String']['output']>;
  usersWithAccess: Array<LicenseSystemAccessUserItem>;
};

export type GetLicenseSystemUpdateInput = {
  licenseSystemId: Scalars['ID']['input'];
  orgId: Scalars['String']['input'];
};

export type GetLicenseSystemUpdatePayload = {
  __typename?: 'GetLicenseSystemUpdatePayload';
  updateBinaryData?: Maybe<Scalars['String']['output']>;
  updateNumber?: Maybe<Scalars['Int']['output']>;
};

export type GetLicenseSystemsForColorProofGoPayload = {
  __typename?: 'GetLicenseSystemsForColorProofGoPayload';
  licenseSystems: Array<LicenseSystemForColorProofGo>;
};

export type GetOrganizationPayload = {
  __typename?: 'GetOrganizationPayload';
  maintainableRoles: Array<Role>;
  organization?: Maybe<Organization>;
};

export type GetOrganizationSitesPayload = {
  __typename?: 'GetOrganizationSitesPayload';
  items: Array<Organization>;
};

export type GetPathPayload = {
  __typename?: 'GetPathPayload';
  path: Array<PathElement>;
};

export type GetSignedInUserPayload = {
  __typename?: 'GetSignedInUserPayload';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  modules: Array<Scalars['String']['output']>;
  orgId: Scalars['ID']['output'];
  orgName: Scalars['String']['output'];
  role: Role;
};

export type GetUserDetailsInput = {
  targetUserId: Scalars['ID']['input'];
};

export type GetUserDetailsPayload = {
  __typename?: 'GetUserDetailsPayload';
  groups: Array<Group>;
  user: User;
};

export type Group = {
  __typename?: 'Group';
  folderCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  userCount: Scalars['Int']['output'];
};

export type InstalledApplicationDetails = {
  __typename?: 'InstalledApplicationDetails';
  lastSeenDate?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  creationDate: Scalars['String']['output'];
  expiryDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  orgId: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  state: InvitationState;
};

export enum InvitationState {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

export type InviteUserInput = {
  email: Scalars['String']['input'];
  /**   TODO: Make firstName and lastName required once the frontend supports it. Remove groups. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  groups: Array<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  licenseSystemAccess?: InputMaybe<LicenseSystemAccess>;
  modules: Array<Scalars['String']['input']>;
  orgId: Scalars['ID']['input'];
  role: Role;
};

export type InvitedUserPayload = {
  __typename?: 'InvitedUserPayload';
  id: Scalars['ID']['output'];
};

export type InviteeConstraint = {
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};

export enum Language {
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR',
  It = 'IT',
  Ja = 'JA',
  Ko = 'KO',
  Pt = 'PT',
  Zh = 'ZH',
  Zhhant = 'ZHHANT'
}

export type License = {
  __typename?: 'License';
  expirationDate: Scalars['String']['output'];
  installedApplication?: Maybe<InstalledApplicationDetails>;
  name: Scalars['String']['output'];
  options: Array<LicenseOption>;
  productLine?: Maybe<ProductLine>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LicenseOption = {
  __typename?: 'LicenseOption';
  expirationDate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type LicenseSystem = {
  __typename?: 'LicenseSystem';
  admin: Admin;
  appServiceVersion?: Maybe<Scalars['String']['output']>;
  computerName?: Maybe<Scalars['String']['output']>;
  cpGo: ColorProofGoAttributes;
  hasPendingProcess: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isLicenseSystemUpdateAvailable: Scalars['Boolean']['output'];
  isSucActive: Scalars['Boolean']['output'];
  isTransferSupported: Scalars['Boolean']['output'];
  lastChangeDate: Scalars['String']['output'];
  lastSeenDate?: Maybe<Scalars['String']['output']>;
  licenseSystemType?: Maybe<LicenseSystemType>;
  licenses?: Maybe<Array<Maybe<License>>>;
  location?: Maybe<Scalars['String']['output']>;
  orgId: Scalars['String']['output'];
  updateNumber?: Maybe<Scalars['Int']['output']>;
  updateTimeStamp?: Maybe<Scalars['String']['output']>;
};

export type LicenseSystemAccess = {
  colorCard?: InputMaybe<LicenseSystemAccessInput>;
  colorProofGO?: InputMaybe<LicenseSystemAccessInput>;
};

export type LicenseSystemAccessInput = {
  licenseSystemIds: Array<Scalars['ID']['input']>;
  role: LicenseSystemAccessRole;
};

export type LicenseSystemAccessItem = {
  __typename?: 'LicenseSystemAccessItem';
  licenseSystemId: Scalars['ID']['output'];
  role: LicenseSystemAccessRole;
};

export enum LicenseSystemAccessRole {
  Operator = 'Operator',
  Viewer = 'Viewer'
}

export type LicenseSystemAccessUserItem = {
  __typename?: 'LicenseSystemAccessUserItem';
  email: Scalars['String']['output'];
  moduleId: Scalars['ID']['output'];
  role?: Maybe<LicenseSystemAccessRole>;
  userId: Scalars['ID']['output'];
};

export enum LicenseSystemChangedChangeType {
  AddLicenseSystemCompleted = 'AddLicenseSystemCompleted',
  AddLicenseSystemFailed = 'AddLicenseSystemFailed',
  AddLicenseSystemStarted = 'AddLicenseSystemStarted',
  LicenseSystemUpdated = 'LicenseSystemUpdated',
  ReactivateLicenseSystemCompleted = 'ReactivateLicenseSystemCompleted',
  ReactivateLicenseSystemFailed = 'ReactivateLicenseSystemFailed',
  ReactivateLicenseSystemStarted = 'ReactivateLicenseSystemStarted',
  TransferAccepted = 'TransferAccepted',
  TransferCompleted = 'TransferCompleted',
  TransferFailed = 'TransferFailed',
  TransferStarted = 'TransferStarted'
}

export type LicenseSystemChangedInput = {
  changeType: LicenseSystemChangedChangeType;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorType?: InputMaybe<Scalars['String']['input']>;
  licenseSystemId?: InputMaybe<Scalars['ID']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  sourceLicenseSystemId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<LicenseSystemTransferStatus>;
  targetLicenseSystemId?: InputMaybe<Scalars['ID']['input']>;
};

export type LicenseSystemChangedPayload = {
  __typename?: 'LicenseSystemChangedPayload';
  changeType: LicenseSystemChangedChangeType;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  licenseSystemId?: Maybe<Scalars['ID']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  sourceLicenseSystemId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<LicenseSystemTransferStatus>;
  targetLicenseSystemId?: Maybe<Scalars['ID']['output']>;
};

export type LicenseSystemFailureError = {
  __typename?: 'LicenseSystemFailureError';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<OnlineLicenseSystemErrorType>;
};

export type LicenseSystemFailureInput = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorType: OnlineLicenseSystemErrorType;
};

export type LicenseSystemForColorProofGo = {
  __typename?: 'LicenseSystemForColorProofGo';
  computerName?: Maybe<Scalars['String']['output']>;
  cpGo: ColorProofGoAttributes;
  lastChangeDate: Scalars['String']['output'];
  licenseSystemId: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export enum LicenseSystemTransferStatus {
  Accepted = 'Accepted',
  Completed = 'Completed',
  Failed = 'Failed',
  Pending = 'Pending'
}

export enum LicenseSystemType {
  Dongle = 'Dongle',
  Online = 'Online',
  Software = 'Software'
}

export type ListActivitiesByOrgIdPayload = {
  __typename?: 'ListActivitiesByOrgIdPayload';
  activities: Array<ActivityLog>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type ListFoldersInput = {
  parentFolderId?: InputMaybe<Scalars['ID']['input']>;
};

export type ListFoldersPayload = {
  __typename?: 'ListFoldersPayload';
  subfolders?: Maybe<Array<Folder>>;
};

export type ListInvitationsInput = {
  orgId: Scalars['ID']['input'];
};

export type ListInvitationsPayload = {
  __typename?: 'ListInvitationsPayload';
  invitations?: Maybe<Array<Invitation>>;
};

/**  Payload types */
export type ListOrganizationsPayload = {
  __typename?: 'ListOrganizationsPayload';
  items?: Maybe<Array<Maybe<Organization>>>;
};

export type MarkUserInvitationAsVisitedInput = {
  targetUserId: Scalars['ID']['input'];
};

export type MarkUserInvitationAsVisitedPayload = {
  __typename?: 'MarkUserInvitationAsVisitedPayload';
  isSignedUp: Scalars['Boolean']['output'];
};

export type Module = {
  __typename?: 'Module';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum ModuleName {
  ColorCard = 'ColorCard',
  ColorProofGo = 'ColorProofGO',
  Measure = 'Measure',
  Optimize = 'Optimize',
  PhotoshopPluginBasic = 'PhotoshopPluginBasic',
  PhotoshopPluginInternal = 'PhotoshopPluginINTERNAL',
  PhotoshopPluginPackaging = 'PhotoshopPluginPackaging',
  VectorPlugin = 'VectorPlugin'
}

export type MoveFoldersInput = {
  folderIds: Array<Scalars['ID']['input']>;
  targetParentFolderId: Scalars['ID']['input'];
};

export type MoveFoldersPayload = {
  __typename?: 'MoveFoldersPayload';
  succeeded: Scalars['Boolean']['output'];
};

export type MoveLicenseSystemInput = {
  sourceLicenseSystemId: Scalars['ID']['input'];
  targetLicenseSystemId: Scalars['ID']['input'];
};

export type MoveLicenseSystemPayload = {
  __typename?: 'MoveLicenseSystemPayload';
  messageId: Scalars['String']['output'];
  sourceLicenseSystemId: Scalars['ID']['output'];
  succeeded: Scalars['Boolean']['output'];
  targetLicenseSystemId: Scalars['ID']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation: AcceptInvitationPayload;
  addLicenseSystem: AddLicenseSystemPayload;
  addOrganization?: Maybe<AddOrDeleteOrganizationPayload>;
  assignLicenseSystemToOrg: AssignLicenseSystemToOrgPayload;
  assignSitesToOrganization: AssignSitesToOrganizationPayload;
  closeActiveUserSessions: CloseActiveUserSessionsPayload;
  completeAddLicenseSystem: CompleteAddLicenseSystemPayload;
  completeReactivateLicenseSystem: CompleteReactivateLicenseSystemPayload;
  createFolder: CreateOrEditFolderPayload;
  createLicenseSystemAccess: CreateLicenseSystemAccessPayload;
  createOrEditUser?: Maybe<ProcessedUserPayload>;
  createTemporaryLicenses: CreateTemporaryLicensesPayload;
  deleteFolder?: Maybe<DeleteFolderPayload>;
  deleteOrganization?: Maybe<AddOrDeleteOrganizationPayload>;
  deleteUser?: Maybe<ProcessedUserPayload>;
  editFolder: CreateOrEditFolderPayload;
  editLicenseSystem: EditLicenseSystemPayload;
  editOrganization?: Maybe<EditOrganizationPayload>;
  inviteUser: InvitedUserPayload;
  markUserInvitationAsVisited: MarkUserInvitationAsVisitedPayload;
  moveFolders: MoveFoldersPayload;
  moveLicenseSystem: MoveLicenseSystemPayload;
  publishOrgWideEvent: OrgWideEventPayload;
  reactivateLicenseSystem: ReactivateLicenseSystemPayload;
  removeLicenseSystemFromOrg: RemoveLicenseSystemFromOrgPayload;
  resendInvitation: ResendInvitationPayload;
  saveColorProofOnlineStatus: SaveColorProofOnlineStatusPayload;
  setApplicationSettings?: Maybe<ApplicationSettingsPayload>;
  updateUserFullName: UpdateUserFullNamePayload;
  updateUserSettings?: Maybe<UserSettingsPayload>;
};


export type MutationAcceptInvitationArgs = {
  input: AcceptInvitationInput;
};


export type MutationAddLicenseSystemArgs = {
  input: AddLicenseSystemInput;
};


export type MutationAddOrganizationArgs = {
  input: AddOrganizationInput;
};


export type MutationAssignLicenseSystemToOrgArgs = {
  input: AssignLicenseSystemToOrgInput;
};


export type MutationAssignSitesToOrganizationArgs = {
  input: AssignSitesToOrganizationInput;
};


export type MutationCloseActiveUserSessionsArgs = {
  input: CloseActiveUserSessionsInput;
};


export type MutationCompleteAddLicenseSystemArgs = {
  input: CompleteAddLicenseSystemInput;
};


export type MutationCompleteReactivateLicenseSystemArgs = {
  input: CompleteReactivateLicenseSystemInput;
};


export type MutationCreateFolderArgs = {
  input: CreateFolderInput;
};


export type MutationCreateLicenseSystemAccessArgs = {
  input: CreateLicenseSystemAccessInput;
};


export type MutationCreateOrEditUserArgs = {
  input: CreateOrEditUserInput;
};


export type MutationCreateTemporaryLicensesArgs = {
  input: CreateTemporaryLicensesInput;
};


export type MutationDeleteFolderArgs = {
  input: DeleteFolderInput;
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  input: DeleteOrganizationReferenceInput;
};


export type MutationEditFolderArgs = {
  input: EditFolderInput;
};


export type MutationEditLicenseSystemArgs = {
  input: EditLicenseSystemInput;
};


export type MutationEditOrganizationArgs = {
  input: EditOrganizationInput;
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationMarkUserInvitationAsVisitedArgs = {
  input: MarkUserInvitationAsVisitedInput;
};


export type MutationMoveFoldersArgs = {
  input: MoveFoldersInput;
};


export type MutationMoveLicenseSystemArgs = {
  input: MoveLicenseSystemInput;
};


export type MutationPublishOrgWideEventArgs = {
  input: PublishOrgWideEventInput;
};


export type MutationReactivateLicenseSystemArgs = {
  input: ReactivateLicenseSystemInput;
};


export type MutationRemoveLicenseSystemFromOrgArgs = {
  input: RemoveLicenseSystemFromOrgInput;
};


export type MutationResendInvitationArgs = {
  input: ResendInvitationInput;
};


export type MutationSaveColorProofOnlineStatusArgs = {
  input: SaveColorProofOnlineStatusInput;
};


export type MutationSetApplicationSettingsArgs = {
  input: SetApplicationSettingsInput;
};


export type MutationUpdateUserFullNameArgs = {
  input: UpdateUserFullNameInput;
};


export type MutationUpdateUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};

export type NearestExpiringContract = {
  __typename?: 'NearestExpiringContract';
  autoRenewal: Scalars['Boolean']['output'];
  expirationDate?: Maybe<Scalars['String']['output']>;
  hasExpired: Scalars['Boolean']['output'];
};

export enum OnlineLicenseSystemErrorType {
  AssignedToDifferentOrg = 'AssignedToDifferentOrg',
  AutomatedLicenseTransferDeactivated = 'AutomatedLicenseTransferDeactivated',
  OlsExistsWithDiffSrNo = 'OLSExistsWithDiffSrNo',
  OlsExistsWithSameSrNo = 'OLSExistsWithSameSrNo',
  ReactivationLimitReached = 'ReactivationLimitReached',
  Unknown = 'Unknown'
}

export type OrgWideEventPayload = {
  __typename?: 'OrgWideEventPayload';
  eventType: OrgWideEventType;
  licenseSystemChanged?: Maybe<LicenseSystemChangedPayload>;
  orgId: Scalars['ID']['output'];
};

export enum OrgWideEventType {
  LicenseSystemChanged = 'LicenseSystemChanged'
}

/**  Main types */
export type Organization = {
  __typename?: 'Organization';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  code: Scalars['String']['output'];
  contactEmail: Scalars['String']['output'];
  contactPerson?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  groups?: Maybe<Array<Group>>;
  id?: Maybe<Scalars['ID']['output']>;
  isAllowedToUseLicenseSystemsOffline?: Maybe<Scalars['Boolean']['output']>;
  isHeadOrganization?: Maybe<Scalars['Boolean']['output']>;
  licenseSystems: Array<LicenseSystem>;
  licenses: Array<ProductModule>;
  name: Scalars['String']['output'];
  parentOrgData?: Maybe<ParentOrganization>;
  /**
   *   TODO: Remove parentOrgId after PR #214 is merged and clients migrate to parentOrgData.
   * @deprecated Use parentOrgData instead.
   */
  parentOrgId?: Maybe<Scalars['ID']['output']>;
  registration: Scalars['String']['output'];
  rootFolders?: Maybe<Array<Folder>>;
  users?: Maybe<Array<User>>;
  zip: Scalars['String']['output'];
};

export type ParentOrganization = {
  __typename?: 'ParentOrganization';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PathElement = {
  __typename?: 'PathElement';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProcessedUserPayload = {
  __typename?: 'ProcessedUserPayload';
  id?: Maybe<Scalars['ID']['output']>;
};

export type Product = {
  __typename?: 'Product';
  productDefinitions: Array<ProductDefinition>;
  productType: Scalars['String']['output'];
};

export type ProductDefinition = {
  __typename?: 'ProductDefinition';
  downloadUrl: Scalars['String']['output'];
  releaseDate: Scalars['String']['output'];
  type: Scalars['String']['output'];
  version: Scalars['String']['output'];
  whatsNewUrl?: Maybe<WhatsNewUrl>;
};

export enum ProductLine {
  Colorproof = 'COLORPROOF',
  Colorserver = 'COLORSERVER',
  Opencolor = 'OPENCOLOR'
}

export type ProductModule = {
  __typename?: 'ProductModule';
  contractStatus: ContractStatus;
  counterLimit: Scalars['Int']['output'];
  counters?: Maybe<CounterLimit>;
  module: Scalars['String']['output'];
  seats: Seats;
};

export type PublishOrgWideEventInput = {
  eventType: OrgWideEventType;
  licenseSystemChanged?: InputMaybe<LicenseSystemChangedInput>;
  orgId: Scalars['ID']['input'];
};

export type Query = {
  __typename?: 'Query';
  getAllProducts: GetAllProductsPayload;
  getApplicationSettings?: Maybe<ApplicationSettingsPayload>;
  getColorCardBalanceItemsByOrgId: GetColorCardBalanceItemsByOrgIdPayload;
  getFolder?: Maybe<GetFolderPayload>;
  getLicenseSystemAccessByCurrentUser: GetLicenseSystemAccessByCurrentUserPayload;
  getLicenseSystemAccessByUserId?: Maybe<GetLicenseSystemAccessByUserIdPayload>;
  getLicenseSystemDetails?: Maybe<GetLicenseSystemDetailsPayload>;
  getLicenseSystemUpdate?: Maybe<GetLicenseSystemUpdatePayload>;
  getLicenseSystemsByCurrentUser: GetLicenseSystemsForColorProofGoPayload;
  getOrganization?: Maybe<GetOrganizationPayload>;
  getOrganizationSites: GetOrganizationSitesPayload;
  getSignedInUserData?: Maybe<GetSignedInUserPayload>;
  getUserDetails?: Maybe<GetUserDetailsPayload>;
  hasPermissionToPrintColorCard: Scalars['Boolean']['output'];
  listActivitiesByOrgId: ListActivitiesByOrgIdPayload;
  listAllActivitiesInitiatedByGmg: ListActivitiesByOrgIdPayload;
  listFolders?: Maybe<ListFoldersPayload>;
  listInvitations?: Maybe<ListInvitationsPayload>;
  listOrganizations?: Maybe<ListOrganizationsPayload>;
  listUsers: Array<UserInSysAdminView>;
};


export type QueryGetColorCardBalanceItemsByOrgIdArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryGetFolderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLicenseSystemAccessByCurrentUserArgs = {
  input: GetLicenseSystemAccessByCurrentUserInput;
};


export type QueryGetLicenseSystemAccessByUserIdArgs = {
  input: GetLicenseSystemAccessByUserIdInput;
};


export type QueryGetLicenseSystemDetailsArgs = {
  input: GetLicenseSystemDetailsInput;
};


export type QueryGetLicenseSystemUpdateArgs = {
  input: GetLicenseSystemUpdateInput;
};


export type QueryGetOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrganizationSitesArgs = {
  parentOrgId: Scalars['ID']['input'];
};


export type QueryGetUserDetailsArgs = {
  input: GetUserDetailsInput;
};


export type QueryHasPermissionToPrintColorCardArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryListActivitiesByOrgIdArgs = {
  nextCursor?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['ID']['input'];
};


export type QueryListAllActivitiesInitiatedByGmgArgs = {
  nextCursor?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListFoldersArgs = {
  input: ListFoldersInput;
};


export type QueryListInvitationsArgs = {
  input: ListInvitationsInput;
};

export type ReactivateLicenseSystemInput = {
  file: Scalars['String']['input'];
  licenseSystemId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};

export type ReactivateLicenseSystemPayload = {
  __typename?: 'ReactivateLicenseSystemPayload';
  messageId: Scalars['String']['output'];
  succeeded: Scalars['Boolean']['output'];
};

export type RemoveLicenseSystemFromOrgInput = {
  licenseSystemId: Scalars['ID']['input'];
};

export type RemoveLicenseSystemFromOrgPayload = {
  __typename?: 'RemoveLicenseSystemFromOrgPayload';
  licenseSystemId: Scalars['ID']['output'];
  succeeded: Scalars['Boolean']['output'];
};

export type ResendInvitationInput = {
  id: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};

export type ResendInvitationPayload = {
  __typename?: 'ResendInvitationPayload';
  id: Scalars['ID']['output'];
};

export enum Role {
  GmgAdmin = 'GMGAdmin',
  GmgPartner = 'GMGPartner',
  GmgSuperUser = 'GMGSuperUser',
  Member = 'Member',
  OrganizationAdmin = 'OrganizationAdmin',
  OrganizationGroupAdmin = 'OrganizationGroupAdmin'
}

export type SaveColorProofOnlineStatusInput = {
  dongleId: Scalars['String']['input'];
  isColorProofOnline: Scalars['Boolean']['input'];
};

export type SaveColorProofOnlineStatusPayload = {
  __typename?: 'SaveColorProofOnlineStatusPayload';
  succeeded: Scalars['Boolean']['output'];
};

export type Seats = {
  __typename?: 'Seats';
  availableNumber: Scalars['Int']['output'];
  isUnlimited: Scalars['Boolean']['output'];
  numberAssignedToUsers: Scalars['Int']['output'];
  totalNumberInContracts: Scalars['Int']['output'];
};

export type SetApplicationSettingsInput = {
  settings: SettingsInput;
};

export type Setting = {
  __typename?: 'Setting';
  appKeys?: Maybe<Array<Scalars['String']['output']>>;
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SettingsInput = {
  appKeys: Array<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  onChangeOrganizationList?: Maybe<AddOrDeleteOrganizationPayload>;
  onCompleteAddLicenseSystem?: Maybe<CompleteAddLicenseSystemPayload>;
  onCompleteReactivateLicenseSystem?: Maybe<CompleteReactivateLicenseSystemPayload>;
  /**   TODO: add strict org authorization. The orgId argument filters events but does not by itself authorize the subscriber. */
  onOrgWideEvent?: Maybe<OrgWideEventPayload>;
};


export type SubscriptionOnCompleteAddLicenseSystemArgs = {
  messageId: Scalars['String']['input'];
};


export type SubscriptionOnCompleteReactivateLicenseSystemArgs = {
  messageId: Scalars['String']['input'];
};


export type SubscriptionOnOrgWideEventArgs = {
  orgId: Scalars['ID']['input'];
};

export type TargetResource = {
  __typename?: 'TargetResource';
  licenseSystemId?: Maybe<Scalars['ID']['output']>;
  orgId: Scalars['ID']['output'];
  orgName?: Maybe<Scalars['String']['output']>;
  resourceType: Scalars['String']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type UpdateUserFullNameInput = {
  firstName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
};

export type UpdateUserFullNamePayload = {
  __typename?: 'UpdateUserFullNamePayload';
  succeeded: Scalars['Boolean']['output'];
};

export type UpdateUserSettingsInput = {
  language: Language;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  groupNames: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invite?: Maybe<UserInvite>;
  language?: Maybe<Language>;
  lastActivityDate?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  moduleIds: Array<Scalars['String']['output']>;
  orgId: Scalars['ID']['output'];
  role: Role;
};

export type UserGroupFolderParams = {
  __typename?: 'UserGroupFolderParams';
  groupId: Scalars['ID']['output'];
  inherited: Scalars['Boolean']['output'];
};

export type UserInSysAdminView = {
  __typename?: 'UserInSysAdminView';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invite?: Maybe<UserInvite>;
  language?: Maybe<Language>;
  lastActivityDate?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['ID']['output']>;
  orgName?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
};

export type UserInvite = {
  __typename?: 'UserInvite';
  expiresAt: Scalars['String']['output'];
  status: Scalars['String']['output'];
  visitedInvitationLinkAt?: Maybe<Scalars['String']['output']>;
};

export type UserListItem = {
  __typename?: 'UserListItem';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type UserSettingsPayload = {
  __typename?: 'UserSettingsPayload';
  language: Language;
};

export type WebApplication = {
  __typename?: 'WebApplication';
  productType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type WhatsNewUrl = {
  __typename?: 'WhatsNewUrl';
  de: Scalars['String']['output'];
  en: Scalars['String']['output'];
};
